import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Button, Paper, Tooltip, Typography } from "@mui/material";

// Metric card component to display individual metrics
const MetricCard = ({
  icon,
  title,
  value,
  percentage,
  buttonText,
  buttonAction,
  tooltip,
  secondaryValue,
  secondaryLabel,
  secondaryButtonText,
  secondaryButtonAction,
}: any) => (
  <Paper elevation={2} sx={{ p: 2, height: "100%" }}>
    <Box display="flex" alignItems="center" mb={1}>
      {icon}
      <Typography variant="subtitle1" fontWeight="bold" ml={1}>
        {title}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip} arrow placement="top">
          <HelpOutlineIcon
            sx={{
              ml: 0.5,
              fontSize: 16,
              color: "text.secondary",
              cursor: "help",
            }}
          />
        </Tooltip>
      )}
    </Box>
    <Typography variant="h4">
      {value}
    </Typography>
    {buttonText !== undefined && (
      <Button variant={"text"} sx={{ p: 0 }} onClick={buttonAction}>
        {buttonText}
      </Button>
    )}
    {percentage !== undefined && percentage !== null && (
      <Typography variant="body2" color="text.secondary">
        {typeof percentage === "number" ? `${percentage.toFixed(2)}%` : percentage} Rate
      </Typography>
    )}
    {secondaryValue !== undefined && (
      <Box display="flex" alignItems="center" mt={0.5}>
        <Typography variant="body2" color="text.secondary">
          {secondaryValue} {secondaryLabel}
        </Typography>
        {secondaryButtonText && (
          <Button
            variant="text"
            size="small"
            sx={{ p: 0, ml: 1, minWidth: "auto", textTransform: "none" }}
            onClick={secondaryButtonAction}
          >
            {secondaryButtonText}
          </Button>
        )}
      </Box>
    )}
  </Paper>
);

export default MetricCard;
